import React from 'react';
import { OnetrackContext, OnetrackParasm } from './context';

export function useTrack() {
  const context = React.useContext(OnetrackContext);
  const contextRef = React.useRef(context);
  contextRef.current = context;
  return React.useCallback((event: string, params: OnetrackParasm) => {
    const baseParams =
      typeof contextRef.current.params === 'function'
        ? contextRef.current.params()
        : contextRef.current.params;
    window.onetrack('track', event, {
      ...baseParams,
      ...params,
    });
  }, []);
}
